export const enum GAEventName {
  // USER TRACKING
  USER_TRACKING_LOCATION = 'user_tracking_location',
  // HISTORY CHANGE
  HISTORY_CHANGE = 'route_changed',

  // CUSTOMER
  CHANGE_SHIPPING_ADDRESS = 'change_shipping_address',
  CREATE_PAYMENT_METHOD = 'create_payment_method',
  HASHED_EMAIL_CHANGE = 'hashed_email_change',

  // SUBSCRIPTION
  VIEW_SUBSCRIPTION = 'view_subscription',
  ADD_TO_NEXT_ORDER_VIA_MODAL_WINDOW = 'add_to_next_order_via_modal_window',
  ADD_TO_SUBSCRIPTION = 'add_to_subscription',
  ADD_TO_SUBSCRIPTION_VIA_MODAL_WINDOW = 'add_to_subscription_via_modal_window',
  ADD_PROMOCODE = 'add_promocode',
  REMOVE_PROMOCODE = 'remove_promocode',
  ADD_TRAVEL_PACKS_BANNER_BUTTON_CLICK = 'add_travel_packs_banner_button_click',
  PRODUCT_QUANTITY_CHANGE = 'subscription_product_quantity_change',
  TEST_COLLECTION = 'test_collection',
  SUBSCRIPTION_REACTIVATE = 'subscription_reactivate',
  SUBSCRIPTION_SKIP = 'subscription_skip',
  SUBSCRIPTION_CANCEL = 'subscription_cancel',
  SUBSCRIPTION_SHIP_NOW = 'subscription_ship_now',
  SUBSCRIPTION_SHIPMENT_DATE = 'subscription_shipment_date',
  SUBSCRIPTION_PRODUCT_QUANTITY_CHANGE = 'subscription_product_quantity_change',
  SUBSCRIPTION_PRODUCT_SWITCH = 'subscription_product_switch',
  SUBSCRIPTION_PRODUCT_SWITCH_UNDO = 'subscription_product_switch_undo',
  PORTAL_PAYMENT_INFO = 'portal_payment_info',
  PORTAL_SHIPPING_INFO = 'portal_shipping_info',

  // ORDERS
  CHANGE_ORDER_DATE = 'change_order_date',
  SKIP_ORDER = 'skip_order',
  SHIP_NOW = 'ship_now',
  CHANGE_ORDER_PAYMENT_METHOD = 'change_order_payment_method',

  // BUILD_BUNDLE
  PRODUCT_VARIANTS_FOR_CHECKOUT = 'view_item_list',
  ADD_TO_CART_OFFERS = 'addToCart',

  // ECOMMERCE
  VIEW_ITEM_LIST = 'view_item_list',
  ADD_TO_CART = 'add_to_cart',
  VIEW_CART = 'view_cart',
  REMOVE_FROM_CART = 'remove_from_cart',
  BEGIN_CHECKOUT = 'begin_checkout',
  ADD_SHIPPING_INFO = 'add_shipping_info',
  ADD_PAYMENT_INFO = 'add_payment_info',
  PURCHASE = 'purchase',

  // CHECKOUT
  CHECKOUT = 'checkout',
  EXPRESS_CHECKOUT = 'expressCheckout',
  EXPRESS_CHECKOUT_CUSTOM_EVENT = 'customEvent',
  EXPRESS_CHECKOUT_ATTEMPT = 'express_checkout_attempt',
  EXPRESS_CHECKOUT_FAILURE = 'express_checkout_failure',
  UPSCRIBE_CHECKOUT_EVENT = 'Upscribe Analytics Event',
  CHANGE_SHIPPING_INFO = 'change_shipping_info',
  REVIEW_ORDER = 'review_order',
  APPLY_DISCOUNT_SUCCESS = 'apply_discount_success',
  APPLY_DISCOUNT_FAILURE = 'apply_discount_failure',
  CHECKOUT_ERROR = 'checkout_error',
  THANKS_TRUEMED_LOAD = 'test_collection',
  USE_SAVED_ADDRESS_CHECKOUT = 'use_saved_address_checkout',
  DELETE_SAVED_ADDRESS_CHECKOUT = 'delete_saved_address_checkout',
  SUBSCRIPTION_SHIPMENT_FREQUENCY = 'subscription_shipment_frequency',
  SUBSCRIPTION_PAYMENT_INFO = 'subscription_payment_info',
  CHECKOUT_CANCEL = 'checkout_cancel',
  EDIT_PAYMENT_METHOD_CHECKOUT = 'edit_payment_method_checkout',
  DELETE_SAVED_PAYMENT_CHECKOUT = 'delete_saved_payment_checkout',
  ORDER_DETAIL_REVIEW = 'order_detail_review',

  // LOGIN
  SIGN_UP_ATTEMPT = 'sign_up_attempt',
  SIGN_UP = 'sign_up',
  SIGN_UP_FAILURE = 'sign_up_failure',

  LOGIN_ATTEMPT = 'login_attempt',
  LOGIN = 'login',
  LOGIN_FAILURE = 'login_failure',

  CUSTOMER_EVENT = 'customEvent',

  // STUDIO
  BUTTON_CLICK = 'button_click',
  NAVIGATION_CLICK = 'navigation_click',
  MENU_NAV = 'menu_nav',
  INTERNAL_LINK_CLICK = 'internal_link_click',
  VIDEO_START = 'video_start',
  LANGUAGE_PREFERENCE = 'language_preference',
  CURRENCY_PREFERENCE = 'currency_preference',
  NEWSLETTER_SIGNUP_SUCCESS = 'newsletter_signup_complete',
  NEWSLETTER_SIGNUP_FAILURE = 'newsletter_signup_failure',
  LOGOUT = 'logout',
  PURCHASE_INTENT_CTA = 'purchase_intent_cta',
  PRODUCT_SELECTION = 'product_selection',
  SUBSCRIPTION_SELECTION = 'subscription_selection',
  FREQUENCY_SELECTION = 'frequency_selection',
  SUB_AND_SAVE_TOGGLE = 'sub_and_save_toggle',
  SIMPLIFIED_BAB_TOGGLE = 'simplified_bab_toggle',
  VIEW_CONTENT = 'view_content',

  // SHOP
  SUBSCRIPTION_PRODUCT_ADD = 'subscription_product_add',
  REPLACE_SUBSCRIPTION_ITEM = 'replace_subscription_item',
  PRODUCT_CARD_CLICK = 'product_card_click',

  // CART
  CLOSE_CART = 'close_cart',

  // QUIZ
  QUIZ_STARTED = 'quiz_started',
  QUIZ_STEP = 'quiz_step',
  QUIZ_EXIT = 'exit_quiz',
  QUIZ_BACK_BUTTON = 'back_button_click',
  QUIZ_ANSWER_SELECTION = 'answer_selection',
  QUIZ_COMPLETED = 'quiz_completed',
  // deprecated events
  QUIZ_EMAIL_FILL = 'email_fill',
  QUIZ_VIEW_RESULTS = 'view_results',
  QUIZ_POPUP_ACTION = 'popup_action',

  // Rebill
  REBILL_START = 'start_rebill',
  REBILL_DELAY = 'rebill_delay',
  REBILL_MANAGE = 'rebill_manage',
  REBILL_CONFIRM_MANAGE = 'rebill_confirmation_manage',

  // GIFT
  TURN_ON_GIFTING_SHIPPING = 'unified_shipping_gift',
  TURN_ON_GIFTING_ORDER_REVIEW = 'unified_review_gift',

  // FREE GIFT
  CLICK_PROMO_BANNER = 'click_promo_banner',
  SHARE_SECTION_SHARE_PACK = 'share_section_share_packs',
  SHARE_SECTION_ORDER_DETAILS = 'share_section_order_details',
  SHARE_PACKS_MODAL_SUBMIT = 'share_packs_address_modal_submit_checkout',
  SHARE_PACKS_CANCEL_CHECKOUT = 'share_packs_address_modal_cancel_checkout',
  CONFIRMATION_SHARE_PACKS = 'share_confirmation_share_packs',
  CONFIRMATION_ORDER_DETAILS = 'share_confirmation_order_details',
  SUBMIT_SHARE_PACK_FORM = 'share_travel_pack',

  // AB Testing
  TEST_EXPOSURE = 'test_exposure',

  // Dynamic Landers
  DYNAMIC_LANDERS_VIEW = 'dynamic_landers_view',

  // Banners
  BANNER_CLICK = 'banner_click',

  // Klaviyo modal
  POPUP_VIEWED = 'popup_viewed',
  EMAIL_SUBMISSION = 'email_submission',
  PHONE_SUBMISSION = 'phone_submission',

  // Rudderstack ready
  RUDDERSTACK_READY = 'rs_ready',

  // Swap feature
  SWAP_TO_TRAVELPACK_TOGGLE = 'swap_to_travelpack_toggle',
  SWAP_TO_POUCH_TOGGLE = 'swap_to_pouch_toggle',
  NEXT_ORDER_ONLY_TOGGLE = 'next_order_only_toggle',
  SWAP_TO_TRAVELPACK = 'swap_to_travelpack',
  SWAP_TO_POUCH = 'swap_to_pouch',
  NEXT_ORDER_ONLY = 'next_order_only'
}
